import React, { Component } from 'react';
import './addProduct.css'

class AddProduct extends Component {
    render() {
        return (
            <form action="index.html" method="post">
                <h1>Insert Product Details</h1>
                <fieldset>
                    <legend><span className="number">1</span> Your basic info</legend>

                    <label htmlFor="name">Category:</label>
                    <input type="text" id="category" name="category" />

                    <label htmlFor="mail">Name:</label>
                    <input type="text" id="name" name="name" />

                    <label htmlFor="mail">Old Price:</label>
                    <input type="text" id="priceOld" name="priceOld" />

                    <label htmlFor="mail">New Price:</label>
                    <input type="text" id="priceNew" name="priceNew" />

                    <input type="checkbox" id="development" defaultValue="interest_development" name="user_interest" /><label className="light" htmlFor="development">New Product</label><br />

                    <label htmlFor="mail">Product Image:</label>
                    <input type="file" name="image" />

                    <label htmlFor="mail">Available Quantity:</label>
                    <input type="text" id="qty" name="qty" />

                </fieldset>


                <button type="submit">Add Product</button>
            </form>

        );
    }
}

export default AddProduct;
